import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MasterDevice } from "./devices.service";

@Component({
    selector: 'device-edit',
    templateUrl: './edit.html',
    styleUrls:['./edit.scss']
  })

export class DeviceEdit {
    @Input() device: any;
    @Input() masterDevices: Array<MasterDevice>;
    @Input() onSave: any;
    @Input() onCancel: any;

    public showSlaveDevices = false;

    canBeSlave(device) {
        return device.slave_devices.length == 0
    }

    isMasterDevice() {
        return this.device.master_device_id == 0 && this.device.provide_stat_details
    }

    isSaveButtonDisabled(device) {
      return (!this.checkRequiredFieldsForStaticDevice(device) 
        || !this.checkRequiredFieldsForTargetSettings(device)
        || !this.checkStatCopying(device)) 
        ? true 
        : false
    }

    checkRequiredFieldsForStaticDevice(device) {
        return !((device.type == 2) && (!device.name || !device.price || !device.lat || !device.lng || !device.city_id))
    }

    checkRequiredFieldsForTargetSettings(device) {
        return !(device.provide_stat_details && !device.stat_analyse_interval)
    }

    clickProvideStatDetails(device) {
        if ((device.provide_stat_details && this.canBeSlave(device)) || !device.provide_stat_details) {
            device.provide_stat_details = !device.provide_stat_details
        }
    }

    validationMessages = {
      factor: [
        { type: 'min', message: 'Value must be greater than or equal to 0.' },
        { type: 'max', message: 'Value must be less than or equal to 1.' },
        { type: 'zero', message: 'Value must be greater than 0 if master device for statistics copying is selected.' }
      ]
    };

    validateFactor() {
      const value = this.device.stat_master_weight_coefficient;
      if (value < 0) {
        return 'min';
      } else if (value > 1) {
        return 'max';
      } else if (this.device.stat_master_device_id != 0 && (value == null || value == 0)) {
        return 'zero'
      }
      return null;
    }

    checkStatCopying(device) {
      const value = device.stat_master_weight_coefficient;

      if (device.stat_master_device_id != 0 && (device.stat_master_weight_coefficient == null || device.stat_master_weight_coefficient == 0)) {
          return false
      }

      return true
    }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/devices/edit.ts